import { useRef, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
/* eslint-disable react-hooks/exhaustive-deps */

/**
 * Replace this with useEffect when you need to have a nested object as a dependency,
 * which would cause infinite calls (since an object is always diferent to another).
 *
 * To address this we use isEqual to compare object references.
 */

var useEffectDeep = function useEffectDeep(effectFunc, deps) {
  // 1. Store dependencies reference and if it's the first time it should run
  var isFirst = useRef(true);
  var prevDeps = useRef(deps);
  var cleanup = useRef();
  useEffect(function () {
    // 2. Iterate dependencies and determine if anything has changed
    var isSame = prevDeps.current.every(function (dep, index) {
      return isEqual(dep, deps[index]);
    }); // 3. Only run effect if some dep has changed or on mount

    if (isFirst.current || !isSame) {
      cleanup.current = effectFunc();
    } // 4. Update references for next call


    isFirst.current = false;
    prevDeps.current = deps;
    return cleanup.current; // Ignore hooks warning as deps are provided from args.
  }, deps);
};

export { useEffectDeep };